<template>
  <div class="app">
    <div class="section">
      <div class="subtitle is-5">Accueil Affixe2.0</div>
    </div>
    <hr>
    <div class="container">
      <div class="hero">
        <div class="section">
          <div class="hero-body">
            <h1 class="title is-1 has-text-centered">Bienvenue sur Affixe2.0</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home',
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped>
 .app {
   padding-bottom: 720px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue